/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { Button } from 'react-bootstrap';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import * as LoginConstants from './LoginConstants';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import Captcha from './Captcha';
import { LoginUserActions, resetLoginData } from '../Store/Actions/LoginActions';
import { AppConfigDropdownActions, EventsLogActions, resetLogoutData, LogoutActions } from '../../../SharedModule/Store/Actions/AppActions';
import moment from 'moment';

function PasswordForm(props) {
    // Page constants
    const captcha = React.createRef();
    const passwordRef = useRef(null);
    const dispatch = useDispatch();
    let errorMessagesArray = [];
    const [captchaValue, setCaptchaValue] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [termsCheckBox, setTermsCheckBox] = React.useState(false);
    const [openReminder, setOpenReminder] = React.useState(false);
    const [openExpired, setOpenExpired] = React.useState(false);
    const [openToken, setOpenToken] = React.useState(false);
    const [revokeToken, setRevokeToken] = React.useState(false);
    const [reminderDays, setReminderDays] = React.useState(0);
    const [authToken, setAuthToken] = React.useState('');
    const [passwordExpiry, setPasswordExpiry] = React.useState('');
    const [passwordExpiryRem, setPasswordExpiryRem] = React.useState('');
    const [isMFAEnabled, setIsMFAEnabled] = React.useState(true);
    const [mfaValue, setMfaValue] = React.useState('');
    const skipMFAUser = process.env.REACT_APP_SKIP_MFA ? process.env.REACT_APP_SKIP_MFA.split(',') : [];
    const [{
        passwordError,
        captchError,
        termsError
    }, setShowError] = React.useState(false);
    const [{
        passwordErrorText,
        captchErrorText,
        termsErrorText
    }, setShowErrorText] = React.useState('');

    // Field bindings
    const [values, setValues] = React.useState({
        password: ''
    });

    // Dispatch Actions
    const dropDownDispatch = (configKeyList) => dispatch(AppConfigDropdownActions(configKeyList));
    const loginUserDispatch = (loginUserCriteria) => dispatch(LoginUserActions(loginUserCriteria));
    const logoutDispatch = (logoutCriteria) => dispatch(LogoutActions(logoutCriteria));

    const dropdownData = useSelector(state => state.sharedState.appConfigDropdown);
    const loginUserData = useSelector(state => state.loginState.loginUser);
    const logoutData = useSelector(state => state.sharedState.logout);

    useEffect(() => {
        dispatch(resetLogoutData('logout'));
        dispatch(resetLogoutData('refreshToken'));
    }, []);

    useEffect(() => {
        if (dropdownData) {
            props.setSpinnerLoader(false);
            errorMessagesArray = [];
            props.setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(dropdownData, errorMessagesArray, '');
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                systemFailure();
            } else if (dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY && dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.configKey) {
                setIsMFAEnabled(dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY && dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.mfaType && dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.mfaType == 'Off' ? false : true)
                setMfaValue(dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY && dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.mfaType)
                if (dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.configKey === AppConstants.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY) {
                    setPasswordExpiry(dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY.configDetail[0].value);
                }
                if (dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY_REMAINDER && dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY_REMAINDER.configKey === AppConstants.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY_REMAINDER) {
                    setPasswordExpiryRem(dropdownData.NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY_REMAINDER.configDetail[0].value);
                }
                const loginUserRequest = {
                    userId: props.userID ? props.userID : '',
                    password: values.password
                }
                props.setSpinnerLoader(true);
                loginUserDispatch(loginUserRequest);
            } else {
                errorMessagesArray.push(AppConstants.SYSTEM_ERROR);
                systemFailure();
            }
        }
    }, [dropdownData]);
    // commentting to check for pop message

    useEffect(() => {
        if (loginUserData && (!isMFAEnabled || skipMFAUser.includes(props.userID.toUpperCase()))) {
            setOpenReminder(false);
            setOpenExpired(false);
            setOpenToken(false);
            setReminderDays(0);
            props.setSpinnerLoader(false);
            errorMessagesArray = [];
            props.setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(loginUserData, errorMessagesArray, LoginConstants.LOGIN_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                systemFailure();
            } else if (loginUserData.accessToken) {
                setAuthToken(loginUserData.accessToken);
                sessionStorage.setItem('authToken', loginUserData.accessToken);
                let pwdChangeDiff = 0;
                if (loginUserData.pwdLastChanged) {
                    pwdChangeDiff = checkPasswordExpiry(loginUserData.pwdLastChanged);
                }

                if (pwdChangeDiff > +passwordExpiryRem &&
                    pwdChangeDiff <= +passwordExpiry) {
                    // open popup, Yes --> chng pwd, No--> Claims
                    setOpenReminder(true);
                    setOpenExpired(false);
                    setOpenToken(false);
                    checkReminderDays(loginUserData.pwdLastChanged);
                }
                else if (pwdChangeDiff > +passwordExpiry &&
                    pwdChangeDiff <= (+passwordExpiryRem + +passwordExpiry)) {
                    // open popup, OK --> Chnge Pwd, Log evnt
                    const eventLog = {
                        memberId: "",
                        createdBy: props.userID,
                        eventSource: "Login",
                        eventType: "The password has expired",
                        eventDescription: `${props.userID} attempted to log in with expired password.`
                    }
                    dispatch(EventsLogActions(eventLog));
                    setOpenReminder(false);
                    setOpenExpired(true);
                    setOpenToken(false);
                } else if (pwdChangeDiff > (+passwordExpiryRem + +passwordExpiry)) {
                    const eventLog = {
                        memberId: "",
                        createdBy: props.userID,
                        eventSource: "Login",
                        eventType: "The password has been expired for too long",
                        eventDescription: `Member ${props.userID} password has been expired for too long.`
                    }
                    dispatch(EventsLogActions(eventLog));
                    errorMessagesArray.push(LoginConstants.PASSWORD_LONG_EXPIRED_ERROR);
                    systemFailure();
                } else {
                    if (loginUserData.tokenStatus === AppConstants.SUCCESS) {
                        if (loginUserData.passwordChange === true || loginUserData.passwordChange === 'true') {
                            redirectToCP();
                        } else if (loginUserData.passwordChange === false || loginUserData.passwordChange === 'false') {
                            redirectToClaims();
                           
                        } else {
                            if (!errorMessagesArray || (errorMessagesArray && errorMessagesArray.length === 0)) {
                                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                            }
                            systemFailure();
                        }
                    } else {
                        setOpenReminder(false);
                        setOpenExpired(false);
                        setOpenToken(true);
                    }
                }
            } else {
                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                systemFailure();
            }
        }
    }, [loginUserData]);

    useEffect(() => {
        if (logoutData && (!isMFAEnabled || skipMFAUser.includes(props.userID.toUpperCase()))) {
            errorMessagesArray = [];
            props.setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(logoutData, errorMessagesArray, AppConstants.SYSTEM_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                systemFailure();
            } else if (logoutData.status === AppConstants.SUCCESS) {
                dispatch(resetLogoutData('logout'));
                if (revokeToken) {
                    const eventLog = {
                        memberId: "",
                        createdBy: props.userID,
                        eventSource: "Login",
                        eventType: "Failed",
                        eventDescription: `The login attempt by user ${props.userID} has terminated the existing remote session.`
                    }
                    dispatch(EventsLogActions(eventLog));
                    if (loginUserData.passwordChange === true || loginUserData.passwordChange === 'true') {
                        redirectToCP();
                    } else if (loginUserData.passwordChange === false || loginUserData.passwordChange === 'false') {
                        redirectToClaims();
                    } else {
                        if (!errorMessagesArray || (errorMessagesArray && errorMessagesArray.length === 0)) {
                            errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                        }
                        systemFailure();
                    }
                } else {
                    dispatch(resetLoginData('loginUser'));
                    dispatch(resetLogoutData('appConfigDropdown'));
                    sessionStorage.removeItem('authToken');
                    props.setShowPassword(false);
                    props.setValues({
                        userId: ''
                    })
                    setValues({
                        password: ''
                    })
                }
            } else {
                errorMessagesArray.push(AppConstants.SYSTEM_ERROR);
                systemFailure();
            }
        }
    }, [logoutData]);

    // added new only for one validation and redirecting to send MFA

    useEffect(() => {
        if (loginUserData && isMFAEnabled  && !skipMFAUser.includes(props.userID.toUpperCase())) {
            
            props.setSpinnerLoader(false);
            errorMessagesArray = [];
            props.setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(loginUserData, errorMessagesArray, LoginConstants.LOGIN_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                systemFailure();
            } else if (loginUserData.accessToken) {
                setAuthToken(loginUserData.accessToken);
                // sessionStorage.setItem('authToken', loginUserData.accessToken);
                let pwdChangeDiff = 0;
                if (loginUserData.pwdLastChanged) {
                    pwdChangeDiff = checkPasswordExpiry(loginUserData.pwdLastChanged);
                }

                if (pwdChangeDiff > (+passwordExpiryRem + +passwordExpiry)) {
                    const eventLog = {
                        memberId: "",
                        createdBy: props.userID,
                        eventSource: "Login",
                        eventType: "The password has been expired for too long",
                        eventDescription: `Member ${props.userID} password has been expired for too long.`
                    }
                    dispatch(EventsLogActions(eventLog));
                    errorMessagesArray.push(LoginConstants.PASSWORD_LONG_EXPIRED_ERROR);
                    systemFailure();
                } else {
                    redirectToSendMFA();
                }
            } else {
                errorMessagesArray.push(LoginConstants.LOGIN_TECHNICAL_ERROR);
                systemFailure();
            }
        }
    }, [loginUserData]);


    // Method to set field values on change
    const handleChanges = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

    // Method to set Terms Check Box
    const handleChangeTermCheckBox = () => {
        setTermsCheckBox(!termsCheckBox);
    };

    // Method to set Captcha
    const handleChangeCaptcha = (value) => {
        setCaptchaValue(value);
    };

    // Moving cursor to the end of the text
    useEffect(() => {
        if (passwordRef && passwordRef.current) {
            passwordRef.current.selectionStart = passwordRef.current.value.length;
            passwordRef.current.selectionEnd = passwordRef.current.value.length;
        }
    }, [showPassword]);

    // Method to handle Password visibility
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
        passwordRef.current.focus();
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    // Method to set system failure values
    const systemFailure = () => {
        if (errorMessagesArray[0].indexOf(LoginConstants.LOGIN_TECHNICAL_ERROR) > -1) {
            let statusCode = '';
            if (loginUserData.systemFailure) {
                statusCode = 500;
            }
            else {
                statusCode = loginUserData.status ? loginUserData.status : 500;
            }
            const eventLog = {
                memberId: "",
                createdBy: props.userID,
                eventSource: "Login",
                eventType: "Failed",
                eventDescription: `Login attempt by Member ${props.userID} failed because of status code ${statusCode}.`
            }
            dispatch(EventsLogActions(eventLog));
        }
        dispatch(resetLoginData('loginUser'));
        dispatch(resetLogoutData('logout'));
        dispatch(resetLogoutData('appConfigDropdown'));
        props.setErrorMessages(errorMessagesArray);
        sessionStorage.removeItem('authToken');
        props.setShowPassword(false);
        props.setValues({
            userId: ''
        })
        setValues({
            password: ''
        })
    }

    // Method to validate Password Form
    const validatePasswordForm = () => {
        var passwordError; var captchError; var termsError = false;
        var passwordErrorText; var captchErrorText; var termsErrorText = '';

        // Logic to check for skipping captcha start
        var skipCount = 0;
        const captchaDisbledList = process.env.REACT_APP_CAPTCHA_DISABLED_USERID ? process.env.REACT_APP_CAPTCHA_DISABLED_USERID.split(",") : null;

        if (captchaDisbledList && captchaDisbledList.length > 0) {
            for (var i = 0; i < captchaDisbledList.length; i++) {
                if ((props.userID).trim().toLowerCase() === captchaDisbledList[i].toLowerCase()) {
                    skipCount++;
                    break;
                }
            }
        }
        // Logic to check for skipping captcha end

        if (values.password === '' || (values.password && values.password.trim() === '')) {
            passwordError = true;
            passwordErrorText = LoginConstants.PASSWORD + LoginConstants.REQUIRED;
            errorMessagesArray.push(passwordErrorText);
        }
        if (captchaValue === '' && skipCount === 0) {
            captchError = true;
            captchErrorText = LoginConstants.CAPTCHA_ERROR;
            errorMessagesArray.push(captchErrorText);
        }
        if (!termsCheckBox) {
            termsError = true;
            termsErrorText = LoginConstants.TERMS_ERROR;
            errorMessagesArray.push(termsErrorText);
        }

        props.setErrorMessages(errorMessagesArray);
        setShowError({
            passwordError: passwordError,
            captchError: captchError,
            termsError: termsError
        });
        setShowErrorText({
            passwordErrorText: passwordErrorText,
            captchErrorText: captchErrorText,
            termsErrorText: termsErrorText
        });

        if (errorMessagesArray && errorMessagesArray.length > 0) {
            return true
        } else {
            return false;
        }
    };

    // Method to submit Login Form
    const submitPasswordForm = () => {
        errorMessagesArray = [];
        props.setErrorMessages([]);
        if (!validatePasswordForm()) {
            props.setSpinnerLoader(true);
            const configKeyList = ["NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY", "NUMBER_OF_DAYS_FOR_PASSWORD_EXPIRY_REMAINDER"];
            dropDownDispatch(configKeyList);
        }
    };

    // Method to check if Password has expired
    const checkPasswordExpiry = (pwdLastChanged) => {
        const char = "T";
        const position = 8;
        const pwdChangedDate = moment([pwdLastChanged.slice(0, position), char, pwdLastChanged.slice(position)].join(''));

        const today = moment(new Date());
        const diff = today.diff(pwdChangedDate, 'days');

        return diff;
    }

    // Method to calculate the remaining days for password Expiry
    const checkReminderDays = (pwdLastChanged) => {
        const char = "T";
        const position = 8;
        const pwdChangedDate = moment([pwdLastChanged.slice(0, position), char, pwdLastChanged.slice(position)].join(''));

        const expiryRemDate = moment(pwdChangedDate, "DD-MM-YYYY").add(+passwordExpiry + 1, 'days');

        const today = moment(new Date());
        const diff = expiryRemDate.diff(today, 'days');

        setReminderDays(diff);
    }

    // Method to redirect to ChangePassword
    const redirectToCP = () => {
        const userName = (loginUserData.firstName ? loginUserData.firstName : '') + ' ' + (loginUserData.lastName ? loginUserData.lastName : '');
        const eventLog = {
            memberId: "",
            createdBy: props.userID,
            eventSource: "Login",
            eventType: "Login Success",
            eventDescription: `Member ${props.userID} has successfully logged into the system at ${new Date()}.`
        }
        dispatch(EventsLogActions(eventLog));
        dispatch(resetLogoutData('appConfigDropdown'));
        captcha.current.reset();
        sessionStorage.setItem('authToken', authToken ? authToken : loginUserData.accessToken);
        props.history.push({
            pathname: '/changePassword',
            state: { userID: props.userID ? props.userID : '', source: 'Login', loginTime: new Date(), userName: userName,
            refreshToken: loginUserData.refreshToken, expiresIn: loginUserData.expiresIn }
        });
    }

    // Method to redirect to Claims
    const redirectToClaims = () => {
        const userName = (loginUserData.firstName ? loginUserData.firstName : '') + ' ' + (loginUserData.lastName ? loginUserData.lastName : '');
        const eventLog = {
            memberId: "",
            createdBy: props.userID,
            eventSource: "Login",
            eventType: "Login Success",
            eventDescription: `Member ${props.userID} has successfully logged into the system at ${new Date()}.`
        }
        dispatch(EventsLogActions(eventLog));
        dispatch(resetLogoutData('appConfigDropdown'));
        captcha.current.reset();
        sessionStorage.setItem('authToken', authToken ? authToken : loginUserData.accessToken);
        props.history.push({
            pathname: '/claims',
            state: { userID: props.userID ? props.userID : '', loginTime: new Date(), userName: userName,
            refreshToken: loginUserData.refreshToken, expiresIn: loginUserData.expiresIn }
        });
    }

    // Method to redirect to Send MFA Code
    const redirectToSendMFA = () => {
        const userName = (loginUserData.firstName ? loginUserData.firstName : '') + ' ' + (loginUserData.lastName ? loginUserData.lastName : '');
        const eventLog = {
            memberId: "",
            createdBy: props.userID,
            eventSource: "Login",
            eventType: "Login Success",
            eventDescription: `Member ${props.userID} has successfully sent OTP at ${new Date()}.`
        }
        dispatch(EventsLogActions(eventLog));
        dispatch(resetLogoutData('appConfigDropdown'));
        captcha.current.reset();
        // sessionStorage.setItem('authToken', authToken ? authToken : loginUserData.accessToken);
        props.history.push({
            pathname: '/sendMFACode',
            state: { userID: props.userID ? props.userID : '', loginTime: new Date(), userName: userName,
            refreshToken: loginUserData.refreshToken, expiresIn: loginUserData.expiresIn,
            email: loginUserData.email, mobileNumber: loginUserData.phoneNumber, fromPath: 'password',
            passwordExpiry: passwordExpiry, passwordExpiryRem: passwordExpiryRem,
            mfaValue : mfaValue
         }
        });
    }

    // Method to handle revoke previous session
    const handleRevoke = () => {
        setRevokeToken(true);
        setOpenToken(false);
        const logoutRequest = {
            logoutType: "Revoke",
            userId: props.userID ? props.userID : ''
        }
        logoutDispatch(logoutRequest);
    }

    // Method to handle Logout on click of No
    const handleLogout = () => {
        setRevokeToken(false);
        setOpenToken(false);
        const logoutRequest = {
            logoutType: "logout",
            userId: props.userID ? props.userID : ''
        }
        logoutDispatch(logoutRequest);
    }

    return (
        <>
            <div className="col px-lg-0">
                <div className="">
                    <div className="login-header pb-0">PASSWORD</div>
                </div>
                <div className="login-form-container">
                    <form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
                        <div className="p-2">
                            <div className="form-wrapper col pl-0">
                                <div className="mui-custom-form mx-3">
                                    <TextField
                                        inputRef={passwordRef}
                                        id="standard-password"
                                        required
                                        type={showPassword ? 'text' : 'password'}
                                        label="Password"
                                        fullWidth
                                        value={values.password}
                                        onChange={handleChanges('password')}
                                        onBlur={() => setShowPassword(false)}
                                        placeholder=""
                                        inputProps={{ maxLength: 20 }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">
                                                <IconButton
                                                    id="pass"
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                >
                                                    {values.password ? !showPassword ? <Visibility /> : <VisibilityOff /> : null}
                                                </IconButton>
                                            </InputAdornment>
                                        }}
                                        error={passwordError}
                                        helperText={passwordError ? passwordErrorText : null}
                                    />
                                </div>
                                <Captcha handleChangeCaptcha={handleChangeCaptcha} captcha={captcha} />
                                {captchError ? <p className=" mui-custom-form attest-error mx-3 mt-lg-3 mt-md-2 my-0">{captchErrorText}</p> : null}
                                <FormControlLabel
                                    id="terms-condition-checkbox"
                                    className="mui-custom-form"
                                    control={
                                        <Checkbox
                                            id="terms-check"
                                            className={termsError ? "checkbox-error" : null}
                                            name="terms-condition-checkbox"
                                            color="primary"
                                            checked={termsCheckBox}
                                            value={termsCheckBox}
                                            onChange={handleChangeTermCheckBox}
                                        />
                                    }
                                    label={["I have read and agree with the ", <a href="/termsOfUse" target="_blank">Terms of Use</a>, " and ", <a href="/privacyPolicy" target="_blank">Privacy Policy</a>]}
                                />
                                {termsError ? <p className="attest-error mx-3">{termsErrorText}</p> : null}
                            </div>
                            <div className="mui-custom-form my-0 mx-3 mb-2">
                                <Button className='btn-primary btn-primary-pw mt-1 mb-2' onClick={submitPasswordForm}
                                    hidden={!termsCheckBox} aria-hidden={!termsCheckBox}>
                                    LOGIN </Button>
                                <Button className='btn-primary btn-primary-pw mt-1 mb-2' onClick={submitPasswordForm}
                                    hidden={termsCheckBox} aria-hidden={termsCheckBox} disabled>
                                    LOGIN </Button>
                                <br />
                                <a href="/passwordRecovery" className="font-weight-600 mx-1 py-3">Forgot Password/Unlock Account</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <>
                <Dialog className='alert-dialog' open={openReminder}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">Your password will expire in {reminderDays} days. Do you want to change now?</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsConfirm" className="btn btn-primary btn-alert mr-2" onClick={redirectToCP}>YES</Button>
                        <Button id="claimsCancel" className="btn btn-transparent btn-alert" onClick={redirectToClaims}>NO</Button>
                    </div>
                </Dialog>

                <Dialog className='alert-dialog' open={openExpired}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">{LoginConstants.PASSWORD_EXPIRED_ERROR}</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsOk" className="btn btn-primary btn-alert mr-2" onClick={redirectToCP}>OK</Button>
                    </div>
                </Dialog>

                <Dialog className='alert-dialog' open={openToken}>
                    <div className="row">
                        <ErrorOutlineIcon className="alert-font" />
                        <p className="col-md-11 col-sm-11 col-10 px-1 py-3 font-weight-bold">{LoginConstants.PASSWORD_INVALID_TOKEN_ERROR}</p>
                    </div>
                    <div className="flex-row">
                        <Button id="claimsTokenConfirm" className="btn btn-primary btn-alert mr-2" onClick={handleRevoke}>YES</Button>
                        <Button id="claimsTokenCancel" className="btn btn-transparent btn-alert" onClick={handleLogout}>NO</Button>
                    </div>
                </Dialog>
            </>
        </>
    );
}
export default PasswordForm;